<template>
  <div>
    <div class="flex justify-between h-50px items-center border text-sm pl-2">
      <p class="space-x-10 whitespace-nowrap">
        <span>
          <input type="checkbox" @click="checkAll" v-model="checked" />
          {{ $t("全选") }}
        </span>
        <span @click="remove" class="cursor-pointer">{{ $t("删除") }}</span>
        <span class="cursor-pointer" @click="collect">{{
          $t("添加到收藏列表")
        }}</span>
      </p>
      <p class="space-x-4 ml-auto mr-12 whitespace-nowrap">
        <span>
          {{ $t("品类") }}：
          <span>{{ orderLength }}</span>
          {{ $t("种") }}
        </span>
        <span>
          {{ $t("数量") }}：
          <span>{{ orderQuantity }}</span>
          {{ $t("扎") }}
        </span>
        <span>
          {{ $t("预估重量") }}：
          <span>{{ orderWeight }}</span>
          kg
        </span>
        <span>
          {{ $t(" 总计（不含运费）") }}：
          <span class="font-bold text-red-500 text-lg">{{
            $p(orderTotal)
          }}</span>
        </span>
      </p>
      <p class="
                      bg-red-500
                      text-white
                      px-8
                      text-lg
                      h-full
                      cursor-pointer
                      flex-center
                      hover:bg-red-400
                    " @click="payState">
        <span>{{ $t("结算") }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";
import { onMounted, ref, computed } from "@vue/composition-api";
import bus from "@/API/util/bus.js";
export default defineComponent({
  props:{
    curWh:String
  },
  setup(props, ctx) {
    const checkAll = () => {
      bus.emit("checkAll");
    };
    const checked = ref(false);
    const orderQuantity = ref(Number(0));
    const orderTotal = ref(Number(0));
    const orderWeight = ref(Number(0));
    const orderLength = ref(Number(0));
    const orderDetail = ref();
    onMounted(() => {
      bus.on("checked", (...args) => {
        checked.value = args[0];
      });

      bus.on("dealOrder", (e) => {
        orderDetail.value = e;
        orderLength.value = e.length;
        orderTotal.value = e.length
          ? e
            .map((element) => element.quantity * element.product.price)
            .reduce((a, b) => a + b)
            .toFixed(2)
          : 0;
        orderQuantity.value = e.length
          ? e.map((element) => element.quantity).reduce((a, b) => a + b)
          : 0;
        orderWeight.value = e.length
          ? e
            .map((element) => element.quantity * element.product.weight)
            .reduce((a, b) => a + b)
            .toFixed(2)
          : 0;
      });
    });

    //批量删除商品
    const remove = async () => {
      if (orderLength.value) {
        const content = computed(() =>
          checked.value
            ? ctx.root.$t("确定清空购物车")
            : ctx.root.$t("确定删除所选商品")
        );
        const res = await ctx.root.$query(content.value);
        if (res) {
          confirmDelete();
        }
      } else {
        ctx.root.$toast(ctx.root.$t("您还没有选择需要删除的商品"), "warning");
      }
    };
    const confirmDelete = async () => {
      const cids = orderDetail.value.map((item) => item.id);
      await ctx.root
        .$callapi("trade/clearMyCartByIds", {
          cids: cids,
        })
        .then(
          (res) => bus.emit("batchDelCart"),
          ctx.root.$store.commit("BATCH_DELCART", cids)
        );
    };
    const payState = () => {
      if (orderLength.value) {
        console.log(orderDetail.value);
        let cids = orderDetail.value.map(i => i.id)
        let sids = [...new Set(orderDetail.value.map(i => i.product.supplier_info.sid))]
        ctx.root.$router.push({
          path: "/product/dealOrder",
          query: {
            cids: cids.join(','),
            sids: sids.join(','),
            curWh:props.curWh
          }
        })
      } else {
        ctx.root.$toast(ctx.root.$t("你还没有选择结算的商品"), "warning");
      }
    };

    //批量收藏
    const collect = async () => {
      const pids = orderDetail.value.map((item) => item.product.id);
      if (orderLength.value) {
        const res = await ctx.root.$callapi("user/doCollect", {
          model: "product",
          objid: pids,
        });
        if (res.code == 0) {
          bus.emit("batchCollect", pids);
          ctx.root.$toast(ctx.root.$t("添加收藏成功"), "success");
        }
      } else {
        ctx.root.$toast(
          ctx.root.$t("您还没有选择需要添加收藏的商品"),
          "warning"
        );
      }
    };
    return {
      checkAll,
      checked,
      remove,

      orderTotal,
      orderQuantity,
      orderWeight,
      orderLength,
      payState,
      confirmDelete,
      collect,
    };
  },
});
</script>

<style scoped lang="scss">input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  border-radius: 3px;
  outline: none;
}
input[type="checkbox"]:checked {
  --tw-bg-opacity: 1;
  background-color: rgba(5, 150, 105, var(--tw-bg-opacity));
  background-size: 100% 100%;
}
input[type="checkbox"]:checked::after {
  content: "✓";
  color: #fff;
  font-size: 1rem;
  line-height: 1rem;
  font-weight: bold;
  text-align: center;
  display: block;
}</style>
